export const PROJECTS = [
  {
    slug: "scanner-pronto-pdf",
    title: "Scanner Pronto PDF",
    desc: "Document scanner for Android: scan, export to PDF, and save/share locally.",
    tags: ["REACT NATIVE", "ANDROID", "PDF"],
    privacyPolicyUpdatedAt: "2025-12-23",
    storeLinks: {
      googlePlay:
        "https://play.google.com/store/apps/details?id=br.com.huolong.scanprontopdf",
      appStore: null, // quando tiver, coloca o link
    },
  },
  {
    slug: "Qr Code Scanner",
    title: "Qr Code Scanner",
    desc: "QR Code Scanner is the ideal tool for scanning QR codes quickly and easily. With a simple and functional design, our app allows you to scan any QR code with just one tap, without any complications.",
    tags: ["Flutter", "DART", "ANDROID", "QR CODE"],
    privacyPolicyUpdatedAt: "2025-12-23",
    storeLinks: {
      googlePlay:
        "https://play.google.com/store/apps/details?id=br.huolong.labs.scanner",
      appStore: null, // quando tiver, coloca o link
    },
  },
];
